import React from 'react';
import { ModuleBaseModel, ImageModel, LinkModel, ModuleBasePropsModel } from '@/types';
import HomepageHero from './HomepageHero';
import HomepageWhatsNext from './HomepageWhatsNext';
import HomepageTheFuture from './HomepageTheFuture';
import HomepageStats from './HomepageStats';
import HomepageCreateBetterFutures from './HomepageCreateBetterFutures';
import MembershipInstantAccess from './MembershipInstantAccess';
import MembershipTrendsIntelligence from './MembershipTrendsIntelligence';
import MembershipInfoBlock from './MembershipInfoBlock';
import MembershipSupercharge from './MembershipSupercharge';
import MembershipTrusted from './MembershipTrusted';
import MembershipBuild from './MembershipBuild';
import AdvisoryDiscoverThePower from './AdvisoryDiscoverThePower';
import AdvisoryHowCanWeHelpYou from './AdvisoryHowCanWeHelpYou';
import AdvisoryEnergise from './AdvisoryEnergise';
import AdvisoryHelp from './AdvisoryHelp';
import AdvisoryOurExperts from './AdvisoryOurExperts';
import AdvisoryInvest from './AdvisoryInvest';
import ICPInsight from './ICPInsight';
import ICPExpert from './ICPExpert';
import ICPStartshaping from './ICPStartshaping';
import ICPTab from './ICPTab';
import OurWorkCTA from './OurWorkCTA';
import MembershipOurExperts from './MembershipOurExperts';
import BookADemoForm from './BookADemoForm';
import AboutUsMilestones from './AboutUsMilestones';
import AboutUsPillars from './AboutUsPillars';
import AboutUsCTA from './AboutUsCTA';
import CaseStudyQuote from './CaseStudyQuote';
import GlobalDataPower from './GlobalDataPower';
import GlobalDataDecisionEngine from './GlobalDataDecisionEngine';
import GlobalDataProductivity from './GlobalDataProductivity';
import ResourcesNewsletter from './ResourcesNewsletter';

export type SideBySideModuleCard = {
  image?: ImageModel;
  preHeading?: string;
  title?: string;
  text?: string;
  link?: LinkModel;
};

export type SideBySideModuleModel = ModuleBaseModel<
  {
    layout?: string;
    alignment?: 'Left' | 'Right' | '';
    preTitle?: string;
    title?: string;
    description?: string;
    media?: string;
    image?: {
      desktopImage?: ImageModel;
      mobileImage?: ImageModel;
    };
    script?: string;
    link1?: LinkModel;
    link2?: LinkModel;
    cards?: SideBySideModuleCard[];
  } & ModuleBasePropsModel
>;

const SideBySideModule = (data: SideBySideModuleModel) => {
  if (data.props.layout === 'Homepage Hero') return <HomepageHero {...data} />;
  if (data.props.layout === 'Homepage Whats next') return <HomepageWhatsNext {...data} />;
  if (data.props.layout === 'Homepage The Future') return <HomepageTheFuture {...data} />;
  if (data.props.layout === 'Homepage Stats') return <HomepageStats {...data} />;
  if (data.props.layout === 'Homepage Create better futures') return <HomepageCreateBetterFutures {...data} />;
  if (data.props.layout === 'Membership Instant access') return <MembershipInstantAccess {...data} />;
  if (data.props.layout === 'Membership Trends intelligence') return <MembershipTrendsIntelligence {...data} />;
  if (data.props.layout === 'Membership Info Block') return <MembershipInfoBlock {...data} />;
  if (data.props.layout === 'Membership Supercharge') return <MembershipSupercharge {...data} />;
  if (data.props.layout === 'Membership Trusted') return <MembershipTrusted {...data} />;
  if (data.props.layout === 'Membership Build') return <MembershipBuild {...data} />;
  if (data.props.layout === 'Membership Our Experts') return <MembershipOurExperts {...data} />;
  if (data.props.layout === 'Advisory Discover the power') return <AdvisoryDiscoverThePower {...data} />;
  if (data.props.layout === 'Advisory How can we help you') return <AdvisoryHowCanWeHelpYou {...data} />;
  if (data.props.layout === 'Advisory Energise') return <AdvisoryEnergise {...data} />;
  if (data.props.layout === 'Advisory Help') return <AdvisoryHelp {...data} />;
  if (data.props.layout === 'Advisory Our Experts') return <AdvisoryOurExperts {...data} />;
  if (data.props.layout === 'Advisory Invest') return <AdvisoryInvest {...data} />;
  if (data.props.layout === 'ICP Insight') return <ICPInsight {...data} />;
  if (data.props.layout === 'ICP Expert') return <ICPExpert {...data} />;
  if (data.props.layout === 'ICP Start shaping') return <ICPStartshaping {...data} />;
  if (data.props.layout === 'ICP tab') return <ICPTab {...data} />;
  if (data.props.layout === 'Our work CTA') return <OurWorkCTA {...data} />;
  if (data.props.layout === 'Book a Demo Form') return <BookADemoForm {...data} />;
  if (data.props.layout === 'About us Milestones') return <AboutUsMilestones {...data} />;
  if (data.props.layout === 'About us Pillars') return <AboutUsPillars {...data} />;
  if (data.props.layout === 'About us CTA') return <AboutUsCTA {...data} />;
  if (data.props.layout === 'Case Study Quote') return <CaseStudyQuote {...data} />;
  if (data.props.layout === 'GlobalData Power') return <GlobalDataPower {...data} />;
  if (data.props.layout === 'GlobalData decision engine') return <GlobalDataDecisionEngine {...data} />;
  if (data.props.layout === 'GlobalData productivity') return <GlobalDataProductivity {...data} />;
  if (data.props.layout === 'Resources newsletter') return <ResourcesNewsletter {...data} />;

  return (
    <div>
      Layout <strong>{data.props.layout}</strong> not implemented
    </div>
  );
};

export default SideBySideModule;
